export const SET_INVITATION = "SET_INVITATION";
export const CLOSE_INVITATION = "CLOSE_INVITATION";
export const CHECK_INVITATION_STATUS = "CHECK_INVITATION_STATUS";
export const SET_INVITATION_DATA = "SET_INVITATION_DATA";
